import React, { useState, useEffect } from 'react';
import useDarkMode from '../../../hooks/useDarkMode';
import useThemeColor from "../../../hooks/useThemeColor";
import { useSelector } from 'react-redux';
import HashLoader from 'react-spinners/HashLoader';
 
const Preloader = () => {
  const isDarkMode = useDarkMode();

  // Get app settings from Redux
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  

  return (
    <>
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)',
      zIndex: 9998,
    }} />
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: isDarkMode ? '#2d3436' : 'white',
      padding: '30px',
      borderRadius: '12px',
      boxShadow: isDarkMode 
        ? '0 4px 6px rgba(0, 0, 0, 0.3)' 
        : '0 4px 6px rgba(0, 0, 0, 0.1)',
      border: isDarkMode ? '1px solid #404040' : 'none'
    }}>
      <HashLoader 
        color={themeColor} 
        size={50} 
      />
    </div>
  </>
  );
};

export default Preloader;


